import { forwardRef, useEffect, useState } from "react";
import { stockService } from "../../../services/stock.service";
import CreatableSelect from "react-select/creatable";
import { IStockItemOption } from "Dashboard/scenes/Stock/domain/IStockItemOption";

const StockItemSelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IStockItemOption[]>([]);
  const [value, setValue] = useState<IStockItemOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const items = await stockService.getStockInputItems();
      const op = items.map((item) => {
        return {
          label: item.name,
          value: item.itemId,
          itemCode: item.latestItemCode ? item.latestItemCode : undefined,
          knownItemCodes: item.knownItemCodes ? item.knownItemCodes : [],
          quantityUnit: item.latestQuantityUnit
            ? item.latestQuantityUnit.unitId
            : undefined,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
    if (props.itemCode !== undefined) {
      props.setValue(props.itemCode, newValue ? newValue.itemCode : "", {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (props.setKnownItemCodes !== undefined) {
      props.setKnownItemCodes(newValue ? newValue.knownItemCodes : []);
    }
    if (props.quantityUnit !== undefined) {
      props.setValue(props.quantityUnit, newValue ? newValue.quantityUnit : undefined, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
  };

  useEffect(() => {
    const values = options.filter((o) => o.value === props.value);
    if (values[0]) {
      setValue(values[0]);
    } else {
      setValue(undefined);
    }
  }, [options, props.value]);

  const createOption = async (name: string): Promise<IStockItemOption> => {
    try {
      const item = await stockService.createStockInputItem(name);
      return {
        label: item.name,
        value: item.itemId,
        itemCode: item.latestItemCode ? item.latestItemCode : undefined,
        knownItemCodes: item.knownItemCodes ? item.knownItemCodes : [],
        quantityUnit: undefined,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      styles={props.customStyles}
      menuPosition="fixed"
      menuPortalTarget={props.menuPortalTarget ? props.menuPortalTarget : null}
      ref={ref}
      isClearable
      placeholder={""}
      formatCreateLabel={formatCreate}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput ? inputValue : undefined}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(value?.label))}
      options={options}
      value={value}
      {...{ error: props.error }}
    />
  );
});

export default StockItemSelectCreate;
